"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobileChildNavListItems = _interopRequireDefault(require("./mobileChildNavListItems"));
var _toggleMenuItem = _interopRequireDefault(require("./component/toggleMenuItem"));
function MobileNavListItem(navProps) {
  var _navProps$links = navProps.links,
    links = _navProps$links === void 0 ? [] : _navProps$links,
    _navProps$title = navProps.title,
    title = _navProps$title === void 0 ? '' : _navProps$title,
    _navProps$url = navProps.url,
    url = _navProps$url === void 0 ? '' : _navProps$url,
    _navProps$icons = navProps.icons,
    icons = _navProps$icons === void 0 ? {} : _navProps$icons,
    _navProps$secondaryLi = navProps.secondaryLinkText,
    secondaryLinkText = _navProps$secondaryLi === void 0 ? '' : _navProps$secondaryLi,
    _navProps$secondaryLi2 = navProps.secondaryLinkUrl,
    secondaryLinkUrl = _navProps$secondaryLi2 === void 0 ? '' : _navProps$secondaryLi2;
  var up = icons.up,
    down = icons.down;
  var _React$useState = _react.default.useState(false),
    expand = _React$useState[0],
    setExpand = _React$useState[1];
  return _react.default.createElement("li", {
    key: title,
    id: "nav-" + title,
    className: "cmp-mobile-navigation__group__items cmp-mobile-navigation__group__items--level-0",
    "data-locator": title
  }, _react.default.createElement("div", {
    className: "cmp-mobile-navigation__group__container " + (expand && 'is-expanded'),
    onClick: function onClick() {
      return setExpand(!expand);
    }
  }, _react.default.createElement(_toggleMenuItem.default, {
    url: url,
    title: title,
    expand: expand,
    up: up,
    down: down,
    showIcon: links.length > 0
  }), expand && _react.default.createElement("div", {
    className: "border-left"
  })), links.length > 0 && _react.default.createElement("ul", {
    className: "cmp-mobile-navigation__group-wrapper " + (expand ? 'is-expanded' : '')
  }, secondaryLinkUrl && secondaryLinkText && _react.default.createElement("li", {
    className: "secondary-link secondary"
  }, _react.default.createElement("div", {
    className: "cmp-mobile-navigation__group__container secondary"
  }, _react.default.createElement("a", {
    href: secondaryLinkUrl,
    title: secondaryLinkText,
    className: "cmp-mobile-navigation__group__container--link"
  }, secondaryLinkText))), _react.default.createElement(_mobileChildNavListItems.default, {
    links: links,
    customClass: "primary",
    icons: icons
  })));
}
var _default = MobileNavListItem;
exports.default = _default;
module.exports = exports["default"];